'use strict';
import register from './core';
import '../functions/jquery-global.js';
import flatpickr from "flatpickr";
import { Sweden } from 'flatpickr/dist/l10n/sv.js'; import { fileNameValidation, fileSizeValidation } from '../components/file-input';
import { dateValidation } from '../components/date-picker';


register('eventform-validator', function (element) {
  var $eventform = $('#event-form');
  var $element = $(element);
  var eventStartDate = $element.find("#event-start-date");
  var eventEndDate = $element.find("#event-end-date");
  var eventStartTime = $element.find("#event-start-time");
  var eventEndTime = $element.find("#event-end-time");
  let dateTimeValid = false;
  let fileInputValid = true;
  let videolinkInputValid = true;
  let eventlinkInputValid = true;

  var datePickerConfig = {
    dateFormat: "Y-m-d",
    locale: "sv",
    allowInput: true,
    onChange: function (selectedDates, dateStr, instance) {
      validate();
    }
  };
  var timePickerConfig = {
    enableTime: true,
    noCalendar: true,
    time_24hr: true,
    dateFormat: "H:i",
    onChange: function (selectedTime, timeStr, instance) {
      validate();
    }

  };
  flatpickr.localize(Sweden);
  flatpickr(eventStartTime, timePickerConfig);
  flatpickr(eventEndTime, timePickerConfig);

  flatpickr(eventStartDate, datePickerConfig);
  flatpickr(eventEndDate, datePickerConfig);


  var validate = function () {
    $("#error").hide();
    var eventStart = eventStartDate.val() + eventStartTime.val();
    var eventEnd = eventEndDate.val() + eventEndTime.val();

    dateTimeValid = dateValidation(eventStart, eventEnd)
    if (!dateTimeValid) {
      $("#error").show();
    }
    handleSubmitBtn();
  };

  $eventform.on('submit', function (event) {
    $("#videomeeting-link-error").hide();
    var videolink = $("#videomeeting-link").val().trim();
    if (videolink.length > 0) {
      videolinkInputValid = isValidUrl(videolink);
      if (!videolinkInputValid) {
        event.preventDefault();
        $("#videomeeting-link-error").show();
        ScrollTo("#videomeeting-link-label", 200);
        return;
      }
    }

    $("#event-link-error").hide();
    var eventlink = $("#event-link").val().trim();
    if (eventlink.length > 0) {
      eventlinkInputValid = isValidUrl(eventlink);
      if (!eventlinkInputValid) {
        event.preventDefault();
        $("#event-link-error").show();
        ScrollTo("#event-link-label", 200);
        return;
      }
    }
  });

  var imageInput = $element.find("#event-picture");

  imageInput.on('change', function () {
    fileInputValid = fileNameValidation(imageInput) && fileSizeValidation(imageInput);
    handleSubmitBtn();
  });

  function ScrollTo(element, time) {
    var timelength = timelength || 1000;
    $('html, body').animate({
      scrollTop: $(element).offset().top - 100
    }, timelength, function () {
    });
  }

  function isValidUrl(string) {
    try {
      new URL(string);
      if (/\s/.test(string)) {
        // It has any kind of whitespace
        return false;
      }
      if (string.endsWith(".")) {
        return false
      }
      if (!string.includes(".")) {
        return false
      }
      return true;
    } catch (err) {
      return false;
    }
  }

  function handleSubmitBtn() {
    let formValid = dateTimeValid && fileInputValid && videolinkInputValid && eventlinkInputValid;
    $(":submit", $element).prop("disabled", !formValid);
  }
  
});
